import { AppConstants } from "../AppConstants";

const { Projects, Languages } = AppConstants.ImagePaths;

export const ProjectData = [
  {
    id: "1",
    title: "YT-Playlist-Analyser / YT-Bookmarks",
    img: Projects.YTBookmarks,
    demo: "https://github.com/MannMendapara/My-YT-Bookmarks",
    description:
      "Implemented CLI command tool and a Chrome extension to enhance learning from YouTube.",
    technologies: [
      Languages.HTML,
      Languages.CSS,
      Languages.JavaScript,
      Languages.Node,
    ],
  },
  {
    id: "2",
    title: "Medcare-Medlife",
    img: Projects.MedcareMedlife,
    demo: "https://github.com/MannMendapara/Medcare-Medlife",
    description:
      "Worked as a frontend developer for Hospital Management System.",
    technologies: [
      Languages.HTML,
      Languages.CSS,
      Languages.Bootstrap,
      Languages.Python,
      Languages.Django,
    ],
  },
  {
    id: "3",
    title: "The Movie-App",
    img: Projects.MovieApp,
    demo: "https://github.com/MannMendapara/The-Movie-app",
    description:
      "Movie Application for display popular movies includes Add and Remove to your Favorite section.",
    technologies: [
      Languages.React,
      Languages.Bootstrap,
    ],
  },
  {
    id: "4",
    title: "OrganizeMe",
    img: Projects.OrganizeMe,
    demo: "https://github.com/MannMendapara/toodoo",
    description:
      "A task management web app with seamless organization, integrated authentication, and profiles, along with creation and completion tracking features.",
    technologies: [
      Languages.React,
      Languages.SCSS,
      Languages.Node,
      Languages.Express,
      Languages.MongoDB,
    ],
  },
  {
    id: "5",
    title: "Memas",
    img: Projects.Memas,
    demo: "https://github.com/MannMendapara/Memas",
    description:
      "Upload hilarious videos, connect with a vibrant community, and spread joy on Memas – where every upload brings laughter and good vibes!",
    technologies: [
      Languages.React,
      Languages.Material,
      Languages.Firebase,
    ],
  },
  {
    id: "6",
    title: "Camera-Gallery",
    img: Projects.CameraGallery,
    demo: "https://github.com/MannMendapara/camera-gallary",
    description:
      "Camera Application that can take photos and videos and Store them into Gallery.",
    technologies: [
      Languages.HTML,
      Languages.CSS,
      Languages.JavaScript,
    ],
  },
  {
    id: "7",
    title: "WeatherCraft",
    img: Projects.WeatherCraft,
    demo: "https://github.com/MannMendapara/WeatherCraft",
    description:
      "A single-page weather application that displays the current weather information for your entered city.",
    technologies: [
      Languages.HTML,
      Languages.CSS,
      Languages.JavaScript,
    ],
  },
];
